import React from "react";
import _ from "lodash";
import Chartist from "../utils/react-chartist";

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tooltips: [], offset: 0, mounted: false };
    this.onCreated = this.onCreated.bind(this);
    this.onData = this.onData.bind(this);
    this.onDraw = this.onDraw.bind(this);
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  onCreated(data) {
    // Special line bar padding.
    if (this.props.type !== "Line") return;
    if (_.get(this.props, "options.axisY.stretch") === true) return;
    cancelAnimationFrame(this.createdRaf);
    this.createdRaf = requestAnimationFrame(() => {
      const size = _.size(data.axisX.ticks);
      const width = data.chartRect.x2 - data.chartRect.x1;
      const offset = width / size / 2;
      if (this.state.offset !== offset) this.setState({ offset });
    });
  }

  onData({ data }) {
    const { labels, series } = data;
    const { state } = this;
    state.labels = labels;
    state.tooltips = _(labels)
      .keyBy(_.identity)
      .mapValues((_, label) => {
        return { label };
      })
      .value();

    if (this.updated) {
      this.updated = false;
    } else {
      this.updated = true;
      requestAnimationFrame(() => {
        this.setState(state);
      });
    }
  }

  onDraw(item) {
    const {
      state: { labels, tooltips },
    } = this;
    if (!labels) return;

    if (this.props.only && this.props.only !== item.type) {
      item.element.remove();
      return;
    }

    // Rebuild tooltips.
    if (item.type !== "bar") return;
    const label = labels[item.index];
    const tooltip = tooltips[label];
    if (!tooltip) return;
    tooltip.x = Math.max(tooltip.x || 0, _.mean([item.x1, item.x2]));
    tooltip.y = Math.max(tooltip.y || 0, _.mean([item.y1, item.y2]));
  }

  render() {
    const { props, state } = this;
    if (!state.mounted) return <div className="chart-wrapper" />;
    return (
      <div className="chart-wrapper" data-offset={state.offset}>
        <style
          dangerouslySetInnerHTML={{
            __html: `
      		.chart-wrapper[data-offset="${state.offset}"] > div > svg{ transform:translateX(${state.offset}px); }
      	`,
          }}
        />
        <Chartist
          ref="chart"
          {...props}
          listener={{
            draw: this.onDraw,
            data: this.onData,
            created: this.onCreated,
          }}
        />
        {Boolean(props.tooltip && props.type === "Bar") && (
          <div className="tooltips">
            {_.map(_.toArray(state.tooltips), (tooltip, i) => {
              if (!tooltip || !tooltip.x) return;
              return this.props.tooltip(tooltip, i);
            })}
          </div>
        )}
      </div>
    );
  }
}

export default Chart;
